export default "__VITE_ASSET__CIPlNvNc__"